import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: inherit;\n  border-radius: ", ";\n  position: relative;\n  z-index: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: #fff;\n  border-radius: ", ";\n  box-shadow: ", ";\n  display: flex;\n  position: relative;\n\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../utils/styling/styled-components';
import { Alignment } from '../Position';
import { arrowAlignmentResolvers, containerAlignmentResolvers } from './alignment';
export var ARROW_WIDTH = 13;
var Container = styled.div(_templateObject(), function (props) {
  return props.theme.borderRadius.medium;
}, function (props) {
  return props.theme.shadows.lgMedium;
}, function (props) {
  return containerAlignmentResolvers[props.alignment]();
}, function (props) {
  return props.displayArrow && "\n    &::after {\n      border: ".concat(props.arrowSize, "px solid transparent;\n      box-sizing: border-box;\n      content: '';\n      height: ").concat(props.arrowSize * 2, "px;\n      position: absolute;\n      width: ").concat(props.arrowSize * 2, "px;\n\n      ").concat(arrowAlignmentResolvers[props.alignment](props), "\n    }\n  ");
});
var Inner = styled.div(_templateObject2(), function (props) {
  return props.theme.borderRadius.medium;
});
/**
 * Base component for Popover. Contains only the rounded white box and arrow.
 */

export var BasePopover = function BasePopover(_ref) {
  var _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? Alignment.TopCenter : _ref$alignment,
      _ref$arrowColor = _ref.arrowColor,
      arrowColor = _ref$arrowColor === void 0 ? '#fff' : _ref$arrowColor,
      _ref$arrowOffset = _ref.arrowOffset,
      arrowOffset = _ref$arrowOffset === void 0 ? 15 : _ref$arrowOffset,
      _ref$arrowSize = _ref.arrowSize,
      arrowSize = _ref$arrowSize === void 0 ? ARROW_WIDTH : _ref$arrowSize,
      children = _ref.children,
      className = _ref.className,
      _ref$displayArrow = _ref.displayArrow,
      displayArrow = _ref$displayArrow === void 0 ? true : _ref$displayArrow,
      id = _ref.id,
      onClick = _ref.onClick,
      role = _ref.role,
      testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Container, {
    alignment: alignment,
    arrowColor: arrowColor,
    arrowOffset: arrowOffset,
    arrowSize: arrowSize,
    className: className,
    displayArrow: displayArrow,
    id: id,
    onClick: onClick,
    role: role,
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(Inner, null, children));
};